import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { User } from '../api/models/User'
import { usersAPI } from '../api/usersAPI'

export const getUser: any = createAsyncThunk(
  'users/getUser',
  async (userid, { rejectWithValue }) => {
    try {
      const response = await usersAPI.getUser()
      // response.roles = ['Traveller']
      return new User(response)
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const getUserById: any = createAsyncThunk(
  'users/getUserById',
  async (userid, { rejectWithValue }) => {
    try {
      const response = await usersAPI.getUser()
      return new User(response.data)
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const getUserDetailById: any = createAsyncThunk(
  'users/getUserDetailById',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await usersAPI.getUserById(userId)
      return new User(response.data)
    } catch (err) {
      console.log('err', err)
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)
export const getUsersByClientId: any = createAsyncThunk(
  'users/getUsersByClientId',
  async (clientId: string | undefined, { rejectWithValue }) => {
    try {
      if (typeof clientId !== 'undefined' && clientId !== null) {
        var users: any = []
        const response = await usersAPI.getUsersByClientId(clientId)
        response.data.value.forEach((user: any) => {
          users.push(new User(user))
        })
        return users
      } else {
        throw Promise.reject({ reason: 'clientId not defined' })
      }
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const getUsersBySupplierId: any = createAsyncThunk(
  'users/getUsersBySupplierId',
  async (clientId, { rejectWithValue }) => {
    try {
      var users: any = []
      const response = await usersAPI.getUsersBySupplierId(clientId)
      response.data.value.forEach((user: any) => {
        users.push(new User(user))
      })
      return users
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const updateUser = async ({ updatedUser, userid }: any) => {
  const updateResponse = await usersAPI.updateUser(updatedUser, userid)
  return updateResponse
}

export const updateUserById: any = createAsyncThunk(
  'users/updateUserById',
  async ({ updatedUser, userId }: any, { rejectWithValue }) => {
    try {
      const response = await usersAPI.updateUser(updatedUser, userId)
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const changePassword: any = createAsyncThunk(
  'users/changePassword',
  async ({ email, password }: any, { rejectWithValue }) => {
    try {
      const response = await usersAPI.changePassword(email, password)
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const registerUser: any = createAsyncThunk(
  'users/registerUser',
  async (userToRegister, { rejectWithValue }) => {
    try {
      const response = await usersAPI.registerUser(userToRegister)
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const deleteUser: any = createAsyncThunk(
  'users/deleteUser',
  async (userid, { rejectWithValue }) => {
    try {
      const response = await usersAPI.deleteUser(userid)
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const resendEmailConfirmation: any = createAsyncThunk(
  'users/resendEmailConfirmation',
  async (userid, { rejectWithValue }) => {
    try {
      const response = await usersAPI.resendEmailConfirmation(userid)
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const getUserDashboards: any = createAsyncThunk(
  'users/getUserDashboards',
  async (userid, { rejectWithValue }) => {
    try {
      var dashboards: any = []
      const response = await usersAPI.getUserDashboards(userid)

      response.data.value.forEach((dashboard: any) => {
        dashboards.push(dashboard)
      })
      return dashboards
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    token: '',
    user: {},
    dashboards: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUser.fulfilled, (state, action) => {
      state.user = action.payload
    })
    builder.addCase(getUser.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
    builder.addCase(getUserDashboards.fulfilled, (state, action) => {
      state.dashboards = action.payload
    })
    builder.addCase(getUserDashboards.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
    builder.addCase(getUserById.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
    builder.addCase(getUsersByClientId.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
    builder.addCase(updateUserById.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
    builder.addCase(changePassword.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
    builder.addCase(registerUser.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
    builder.addCase(deleteUser.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
    builder.addCase(resendEmailConfirmation.rejected, (state, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
  },
})

export default usersSlice.reducer
